import {
  Checkbox,
  FormControl,
  FormLabel,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Text
} from "@chakra-ui/react";
import React, { memo, useCallback, useMemo } from "react";
import { Controller, useForm } from "react-hook-form";
import { NodeProps } from "reactflow";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";
import { Sprite } from "../../../models/api/sprite";
import { NodeType } from "../../../models/nodeType";
import SelectSprite from "../../base/SelectSprite";
import { FlowNodeWithChildren } from "./FlowNode";

const SpawnSpriteEntityNode: React.FC<NodeProps<NodeType<Sprite>>> = (props) => {
  const {
    id: nodeId,
    data: { color, nodeData },
  } = props;

  const drawShadow = nodeData?.drawShadow ?? false;
  const spriteId = nodeData?.spriteId ?? "";
  const entityIndexZ = nodeData?.entityIndexZ ?? 0;

  const { register, getValues, setValue, control, handleSubmit } = useForm<Sprite>({
    defaultValues: useMemo(
      () => ({
        drawShadow,
        spriteId,
        entityIndexZ,
      }),
      [drawShadow, spriteId, entityIndexZ]
    ),
    mode: "onBlur",
  });

  const { updateNodeData } = useUpdateNodeData<Sprite>(nodeId);

  const handleUpdate = useCallback(
    ({ drawShadow, spriteId, entityIndexZ }: Sprite) => {
      updateNodeData({
        drawShadow,
        spriteId,
        entityIndexZ,
      });
    },
    [updateNodeData, setValue]
  );

  return (
    <>
      <FlowNodeWithChildren {...props}>
        <form className={"nodrag"} onSubmit={handleSubmit(handleUpdate)} onBlur={handleSubmit(handleUpdate)}>
          <SelectSprite
            color={color}
            value={getValues("spriteId")}
            setValue={(value) => setValue("spriteId", value)}
          />

          <FormControl>
            <FormLabel>
              <Text casing={"uppercase"} color={color}>
                Entity Index Z
              </Text>
            </FormLabel>
            <Controller
              name={"entityIndexZ"}
              control={control}
              render={({ field: { ref, value, onChange, onBlur, name } }) => (
                <NumberInput
                  value={value}
                  defaultValue={0}
                  name={name}
                  step={1}
                  ref={ref}
                  onChange={(value) => onChange(Number(value))}
                  onBlur={onBlur}
                >
                  <NumberInputField color={color} borderColor={color} borderRadius={0} borderWidth={2} />
                  <NumberInputStepper>
                    <NumberIncrementStepper color={color} />
                    <NumberDecrementStepper color={color} />
                  </NumberInputStepper>
                </NumberInput>
              )}
            />
          </FormControl>
          <FormControl>
            <FormLabel>
              <Text casing={"uppercase"} color={color}>
                Draw Shadow
              </Text>
            </FormLabel>
            <Checkbox id={"drawShadow"} isRequired {...register("drawShadow")} color={color} />
          </FormControl>
        </form>
      </FlowNodeWithChildren>
    </>
  );
};

export default memo(SpawnSpriteEntityNode);
